var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 pl-0"},[_c('el-card',{staticClass:"box-card col-md-12 mb-4"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('strong',[_c('span',[_vm._v("Auto Care Report")])])]),_c('div',{staticStyle:{"margin":"0px 0px"}})])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }